export default {"src":"/_next/static/media/chart-bar.f2c9a51b.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};